import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-work-play-toggle-tab',
  templateUrl: './work-play-toggle-tab.component.html',
  styleUrls: ['./work-play-toggle-tab.component.scss']
})
export class WorkPlayToggleTabComponent {
  constructor(private router: Router) {}
  
  isActive(path: string): boolean {
    const currentUrl = this.router.url;
    const currentPath = currentUrl.split('?')[0]; // Remove query parameters if present

    if (path === '/') {
      // Return true for root path and specific paths
      const validPaths = ['/', '/chat', '/byod', '/translate', '/transcribe'];
      return validPaths.some(validPath => 
        currentPath === validPath || currentUrl.startsWith(validPath + '?')
      );
    }
    // For other paths, do an exact match or match with query params
    return currentPath === path || currentUrl === path || currentUrl.startsWith(path + '?');
  }
  
  updateRoute(path: string) {
    this.router.navigateByUrl(path);
  }
}
